import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'fgb-ace-jump-layout-page',
  templateUrl: './ace-jump-layout-page.component.html',
  styleUrl: './ace-jump-layout-page.component.scss',
})
export class AceJumpLayoutPageComponent {
  private router = inject(Router);

  get isLeaderboard(): boolean {
    return this.router.isActive('/games/acejump/leaderboard', {
      paths: 'exact',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }
}
